<template>
  <div v-if="folders.length" class="hdp-folders-list">
    <div class="hdp-folders-item" v-for="folder in folders" :key="folder.id" @click="$emit('route', {name: 'FolderView', params: {folderId: folder.id}})">
      <div class="hdp-folder-icon" :class="'hdp-folder-' + folder.id.toString()"></div>
      <div class="hdp-folder-name">{{ folder.name }}</div>
      <div v-if="folder.description" class="hdp-folder-description">{{ folder.description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FoldersList',

  props: {
    folders: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
  .hdp-folders-list {
    text-align: center;
  }
  .hdp-folders-item {
    margin-bottom: 40px;
  }
  .hdp-folder-icon {
    height: 52px;
    width: 100px;
    margin: 0 auto 6px auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .hdp-folder-name {
    margin-bottom: 2px;
    font-size: 20px;
    color: #fff;
  }
  .hdp-folder-description {
    font-size: 14px;
    color: #909294;
  }
  /* Banking */
  .hdp-folder-23000030473 {
    background-image: url('../assets/svg/icon-transfers2.svg');
  }
  /* Verification */
  .hdp-folder-23000030474 {
    background-image: url('../assets/svg/icon-clients2.svg');
  }
  /* Trading Conditions */
  .hdp-folder-23000030476 {
    background-image: url('../assets/svg/icon-conditions2.svg');
  }
  /* Trading platforms */
  .hdp-folder-23000030477 {
    background-image: url('../assets/svg/icon-terminals2.svg');
  }
  /* Trading Transactions */
  .hdp-folder-23000030500 {
    background-image: url('../assets/svg/icon-operations2.svg');
  }
  .hdp-folder-23000030660 {
    background-image: url('../assets/folders/23000030660.svg');
  }
  .hdp-folder-23000030661 {
    background-image: url('../assets/folders/23000030661.svg');
  }
  .hdp-folder-23000030680 {
    background-image: url('../assets/folders/23000030680.svg');
  }
  .hdp-folder-23000030740 {
    background-image: url('../assets/folders/23000030740.svg');
  }
  .hdp-folder-23000030741 {
    background-image: url('../assets/folders/23000030741.svg');
  }
  .hdp-folder-23000030745 {
    background-image: url('../assets/folders/23000030745.svg');
  }
  .hdp-folder-23000030746 {
    background-image: url('../assets/folders/23000030746.svg');
  }
  .hdp-folder-23000030853 {
    background-image: url('../assets/folders/23000030853.svg');
  }
  .hdp-folder-23000030854 {
    background-image: url('../assets/folders/23000030854.svg');
  }
  .hdp-folder-23000030856 {
    background-image: url('../assets/folders/23000030856.svg');
  }
  .hdp-folder-23000030871 {
    background-image: url('../assets/folders/23000030871.svg');
  }
  .hdp-folder-23000030872 {
    background-image: url('../assets/folders/23000030872.svg');
  }
  .hdp-folder-23000030873 {
    background-image: url('../assets/folders/23000030873.svg');
  }
  .hdp-folder-23000030874 {
    background-image: url('../assets/folders/23000030874.svg');
  }
  .hdp-folder-23000030875 {
    background-image: url('../assets/folders/23000030875.svg');
  }
  .hdp-folder-23000030876 {
    background-image: url('../assets/folders/23000030876.svg');
  }
  .hdp-folder-23000030877 {
    background-image: url('../assets/folders/23000030877.svg');
  }
</style>



// WEBPACK FOOTER //
// src/components/FoldersList.vue